"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../axios-client/axios-client.service");
var tariffs_const_1 = require("./tariffs.const");
/**
 * TariffsService
 * @class
 */
var TariffsService = /** @class */ (function () {
    function TariffsService() {
    }
    /**
     * Returns an array of tariffs for a given user(`userUuid`)
     * @param userUuid {string}
     * @returns Tariff[]
     */
    TariffsService.prototype.getIndex = function (userUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = tariffs_const_1.TARIFFS_ENDPOINT.getIndex
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns an array of tariffs for a given company(`newCompanyUuid`)
     * @param newCompanyUuid {string}
     * @returns Tariff[]
     */
    TariffsService.prototype.getIndexCompanyTariff = function (newCompanyUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = tariffs_const_1.TARIFFS_ENDPOINT.getIndexCompanyTariff
            .replace('{{version}}', version)
            .replace('{{newCompanyUuid}}', newCompanyUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns filtered list of calculated distances
     * @param filter {TariffFilter}
     * @returns
     */
    TariffsService.prototype.getLongDistanceCalculator = function (filter, version) {
        if (version === void 0) { version = 'v1'; }
        var url = tariffs_const_1.TARIFFS_ENDPOINT.getLongDistanceCalculator
            .replace('{{version}}', version)
            .replace('{{start}}', filter.from)
            .replace('{{end}}', filter.to)
            .replace('{{insurance}}', filter.insurance)
            .replace('{{estimatedKms}}', filter.distance);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Binds a new tariff to a given user (`userUuid`)
     * @param tariffWithQuotaUuid {string}
     * @param userUuid {string}
     * @param data Partial<Tariff>
     * @returns
     */
    TariffsService.prototype.postTariffToUser = function (tariffWithQuotaUuid, userUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = tariffs_const_1.TARIFFS_ENDPOINT.postTariffToUser
            .replace('{{version}}', version)
            .replace('{{tariffWithQuotaUuid}}', tariffWithQuotaUuid)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Binds a new tariff to a given company (`newCompanyUuid`)
     * @param businessTariffWithQuotaUuid {string}
     * @param newCompanyUuid {string}
     * @param data Partial<Tariff>
     * @returns
     */
    TariffsService.prototype.postTariffToCompany = function (businessTariffWithQuotaUuid, newCompanyUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = tariffs_const_1.TARIFFS_ENDPOINT.postTariffToUser
            .replace('{{version}}', version)
            .replace('{{businessTariffWithQuotaUuid}}', businessTariffWithQuotaUuid)
            .replace('{{newCompanyUuid}}', newCompanyUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    return TariffsService;
}());
/**
 * External TarrifsService Class Instance
 * @namespace
 */
exports.tariffs = new TariffsService();
